import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterBillions,
  labelFormatterMoneyAsInteger,
} from '../../../../../shared/formatters/formatters';
import { RealEstateFinancingChartData } from './types';

export const RealEstateFinancing: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );
  return (
    <ChartCard
      data={chartsDataMarketCycle['releasesRealEstateFinancing']}
      Chart={RealEstateFinancingChart}
      cy={'RealEstateFinancing'}
      id={'realEstateFinancing'}
      requestStatus={requesStatusMarketCycle['releasesRealEstateFinancing']}
    />
  );
};

const RealEstateFinancingChart: React.FC<
  IChartProps<RealEstateFinancingChartData[]>
> = ({ data, cy, id }) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterBillions];
  return (
    <ResponsiveContainer data-cy={`RealEstateFinancing${cy}`}>
      <BarChart
        id={id}
        data={data}
        margin={{
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <YAxis
          tickFormatter={(value: number) =>
            `${labelFormatterMoneyAsInteger(value)}bi`
          }
        />
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Bar
          dataKey="valor_financiamento"
          fill="#BA96D9"
          isAnimationActive={false}
          name={nls.charts.realEstateFinancing.realEstateFinancing}
        >
          <LabelList
            dataKey="valor_financiamento"
            formatter={(value: string | number) =>
              value.toString().replaceAll('.', ',')
            }
            position="top"
            fill="#000"
          />
        </Bar>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
